import {ChevronRightIcon} from "@heroicons/react/24/outline"
import {ReactNode, useEffect, useState} from "react"
import {useSearchParams} from "react-router-dom"
import {
    AccountManagementBannersAddNew
} from "../../../components/account/marketing/banner/AccountManagementBannersAddNew.tsx"
import AccountManagementBannersList
    from "../../../components/account/marketing/banner/AccountManagementBannersList.tsx";
import UtilsHelper from "../../../helpers/utilsHelper.ts";
import AccountLayout from "../../../components/layouts/AccountLayout.tsx";

const ButtonNav = (title: string, description: string, onClick: Function): ReactNode => (
    <button
        className='relative group bg-neutral-900 max-w-lg mb-4 py-10 px-10 rounded-3xl flex w-full items-center justify-between hover:bg-neutral-700 transition-colors'
        onClick={() => onClick()}
    >
        <div className='text-left'>
            <p className='text-2xl'>{title}</p>
            <p className='text-neutral-400 mt-2'>{description}</p>
        </div>
        <ChevronRightIcon className='w-10 h-10'/>
    </button>
)

const ViewTypes = {
    ADD_NEW_BANNER: "ADD_NEW_BANNER",
    ALL_BANNERS: "ALL_BANNERS",
} as const;
type ViewTypes = keyof typeof ViewTypes;

export const AccountManagementBannersPage = () => {
    const [selectedView, setSelectedView] = useState<ViewTypes | null>(null);
    const [searchParams, setSearchParams] = useSearchParams();

    useEffect(() => {
        UtilsHelper.changeWindowDocumentTitle("Zarządzanie banerami");
        const view = searchParams.get('view') as ViewTypes | null;
        if (view === null || Object.values(ViewTypes).includes(view)) {
            setSelectedView(view);
        } else {
            setSelectedView(null);
        }
    }, [searchParams])

    return (
        <AccountLayout>
            {selectedView === null &&
                <>
                    {ButtonNav("Dodaj nowy baner", "Dodaj nowy baner promocyjny", () => {
                        setSearchParams({view: "ADD_NEW_BANNER"})
                    })}
                    {ButtonNav("Edytuj baner", "Zarządzaj istniejącymi banerami", () => {
                        setSearchParams({view: "ALL_BANNERS"})
                    })}
                </>}
            {selectedView === "ADD_NEW_BANNER" &&
                <AccountManagementBannersAddNew/>}
            {selectedView === "ALL_BANNERS" &&
                <AccountManagementBannersList/>}
        </AccountLayout>
    )
}
